import { Routes } from '@angular/router';
import { authGuard, languageBootstrapGuard } from '@core';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () => import('./layouts').then(m => m.MainLayoutComponent),
		canActivate: [authGuard, languageBootstrapGuard],
		children: [
			{
				path: '',
				redirectTo: 'dashboard',
				pathMatch: 'full',
			},
			{
				path: 'dashboard',
				loadChildren: () =>
					import('./features/dashboard/dashboard.routes').then(
						(m) => m.routes
					),
			},
			{
				path: 'household',
				loadChildren: () =>
					import('./features/household/household.routes').then(
						(m) => m.routes
					),
			},
			{
				path: 'settings',
				loadChildren: () =>
					import('./features/settings/settings.routes').then(
						(m) => m.routes
					),
			},
			{
				path: 'reports',
				loadChildren: () =>
					import('./features/reports/reports.routes').then(
						(m) => m.routes
					),
			},
			{
				path: 'categories',
				children: [
					{ path: '', redirectTo: '/settings/categories', pathMatch: 'full' },
					{ path: 'new', redirectTo: '/settings/categories/new', pathMatch: 'full' },
					{ path: ':id', redirectTo: '/settings/categories/:id' },
				],
			},
			{
				path: 'transactions',
				loadChildren: () =>
					import('./features/transactions/transactions.routes').then(
						(m) => m.routes
					),
			},
			{
				path: 'recurring-income',
				children: [
					{ path: '', redirectTo: '/settings/recurring-income', pathMatch: 'full' },
					{ path: 'new', redirectTo: '/settings/recurring-income/new', pathMatch: 'full' },
					{ path: ':id', redirectTo: '/settings/recurring-income/:id' },
				],
			},
			{
				path: 'profile',
				loadChildren: () =>
					import('./features/profile/profile.routes').then(
						(m) => m.routes
					),
			},
		]
	},
	{
		path: 'auth',
		loadComponent: () => import('./layouts').then(m => m.AuthLayoutComponent),
		children: [
			{
				path: '',
				loadChildren: () =>
					import('./features/auth/auth.routes').then((m) => m.routes),
			},
		],
	},
	{ path: '**', redirectTo: '' }
];
